import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'ResetPassword',
  components: {
    NewPasswordComp: require('../../components/newPassword.vue').default,
  },
  data: function () {
    return {
      passwords: { password: '', password2: '', canContinue: false },
      completed: false,
      message: '',
      isInComm: false,
      isResetPassFinished: false,
      hasError: false,

      otpCodeConfirm: '',
      emailPhone:'',
    }
  },
  computed: {
    resetEnabled: function () {
      return !this.isResetPassFinished && this.passwords.canContinue && this.passwords.password.length > 0 && !this.isInComm && !this.completed;
    },
    showHomeButton: function () {
      return this.isResetPassFinished == true && this.$store.state.settings.homeButtonUrl != null && this.$store.state.settings.homeButtonUrl.length > 0;
    }
  },
  methods: {
    redirectLogin() {
      window.location.href = this.$store.state.settings.homeButtonUrl;
    },
    resetPassword() {
      this.hasError = false;
      this.isInComm = true;
      this.$root.$emit('enable_disable_loader', true);
      axios.post('/account/ResetUserPassword', { PasswordResetCode: this.otpCodeConfirm, Password: this.passwords.password })
        .then(response => {
          this.isInComm = false;
          this.completed = true;
          if (response.data.data.status == 0) {
            this.message = 'Password Reset Successfully!';
            this.isResetPassFinished = true;
            this.hasError = false;
            setTimeout(() => {
              this.$router.push('/login')
            }, 3000);
          }
          else {
            this.message = response.data.data.text;
            this.isResetPassFinished = true;
            this.hasError = true;
          }
        })
        .catch(e => {
          this.message = e.message;
          this.isResetPassFinished = true;
          this.hasError = true;
        })
        .finally(this.$root.$emit('enable_disable_loader', false));
    },

    confirmOTP() {

    },
    resendOtp() {
      this.isInComm = true;
      this.$root.$emit('enable_disable_loader', true);
      axios.post('/account/SendResetUserPassword', { Email: this.emailPhone, SendOtpCode: true })
        .then(response => {
          this.isInComm = false;
          this.$root.$emit('enable_disable_loader', false);
          if (response.data.data.status != 0)
            this.$notify({ duration: 10000, group: 'app', text: response.data.data.text, type: 'warn' }); // title: '',
        })
        .catch(e => {
          this.$root.$emit('enable_disable_loader', false);
        })
    },

  },
  created() {
    this.emailPhone = this.$route.params.email_phone;
  },
  mounted() {
    this.isResetPassFinished = false;
    this.hasError = false;
  }
}

